import {
  CircularProgress,
  Divider as MuiDivider,
  Typography as MuiTypography,
} from "@material-ui/core";
import {
  FOR_ME_IS_TRUE,
  gender,
  INITIAL_SUBMIT,
  TEMPORARILY_SAVED,
} from "../../../constants";
import { useMutation, useQuery } from "react-query";

import { Formik } from "formik";
import { Helmet } from "react-helmet-async";
import { Prompt } from "react-router";
import SuccessScreen from "./SuccessScreen";
import { createSingleApplication } from "../../../services/applicationsService";
import { fetchApplicationKinds } from "../../../services/applicationKindsService";
import { fetchDocPerSpecificKind } from "../../../services/documentsPerKindService";
import { fetchPortAuthoritiesForExternalUser } from "../../../services/portAuthoritiesService";
import { spacing } from "@material-ui/system";
import styled from "styled-components/macro";
import useLocale from "../../../hooks/useLocale";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { useMemo, useState } from "react";
import ls from "local-storage";
import { documentsRequiredFiltered } from "../../../utils/nauticalPdcolorFn";

import validationSchemaForMe from "./validation schemas/validationSchemaForMe";
import validationSchemaForOther from "./validation schemas/validationSchemaForOther";
import onSubmit from "./submit function";
import generateInitialValues from "./generateInitialValues";
import Form from "./form";

import { gatewayService } from "../../../services/gatewayService";

const Divider = styled(MuiDivider)(spacing);

const Typography = styled(MuiTypography)(spacing);

const NewApplication = () => {
  const { t } = useLocale();
  const port_auth = useSelector((state) => state?.authReducer?.user?.port_auth);
  const [protocolNumber, setProtocolNumber] = useState("");
  const [error, setError] = useState("");
  const { id, forMe } = useParams();
  const user = useSelector((state) => state?.authReducer?.user);

  const [errorFormik, setErrorFormik] = useState("");
  const [statusAppl, setStatusAppl] = useState(INITIAL_SUBMIT);
  const [nauticalPdColor] = useState(() => ls.get("nauticalPdColor"));

  const { data: gatewayData, isLoading } = useQuery(
    ["gateway", id],
    () =>
      gatewayService({
        id,
        afm: user.afm,
        lastname: user.lastname,
        firstname: user.firstname,
        fathername: user.fathername,
        mothername: user.mothername,
      }),
    {
      retry: 1,
      onError: (error) => {
        setError(error.message);
      },
    }
  );

  const { data: portAuthorities } = useQuery(
    "portAuthorities",
    fetchPortAuthoritiesForExternalUser
  );
  const { data: applicationKinds } = useQuery(
    "applicationKinds",
    fetchApplicationKinds
  );
  const { data: docsPerKind } = useQuery("docPerKindSpecific", () =>
    fetchDocPerSpecificKind(id)
  );

  const { mutate, isLoading: isMutationLoading } = useMutation(
    createSingleApplication,
    {
      onSuccess: (data) => {
        setProtocolNumber(data.data);
        setStatusAppl(TEMPORARILY_SAVED);
      },
      onError: (error) => {
        // console.log("error", error.response.data);
        setError(error.response.data);
      },
    }
  );

  const docsPerKindFiltered = documentsRequiredFiltered(
    docsPerKind,
    nauticalPdColor
  );

  const translatedGender = useMemo(() => {
    return gender?.map((option) => ({
      ...option,
      dscr: t(`${option.dscr}`),
    }));
  }, []);

  const initialValues = useMemo(() => {
    return generateInitialValues(
      id,
      applicationKinds,
      portAuthorities,
      user,
      forMe,
      translatedGender,
      nauticalPdColor,
      t,
      gatewayData
    );
  }, [
    id,
    applicationKinds,
    portAuthorities,
    user,
    forMe,
    nauticalPdColor,
    t,
    gatewayData,
  ]);

  // if (isLoading) {
  //   return (
  //     <>
  //       <Prompt
  //         when={!statusAppl}
  //         message={t(
  //           "Are you sure you want to leave this page? Any unsaved changes will be lost"
  //         )}
  //       />
  //       <Helmet title={t("New application")} />

  //       <Typography variant="h3" gutterBottom>
  //         {t("New application")}
  //       </Typography>

  //       <Divider my={6} />

  //       <CircularProgress />
  //     </>
  //   );
  // }

  return (
    <>
      <Prompt
        when={!statusAppl}
        message={t(
          "Are you sure you want to leave this page? Any unsaved changes will be lost"
        )}
      />

      <Helmet title={t("New application")} />

      <Typography variant="h3" gutterBottom>
        {t("New application")}
      </Typography>

      <Divider my={6} />

      <Formik
        enableReinitialize
        validationSchema={() => {
          if (forMe === FOR_ME_IS_TRUE) {
            return validationSchemaForMe(
              id,
              t,
              docsPerKindFiltered,
              nauticalPdColor
            );
          } else {
            return validationSchemaForOther(
              id,
              t,
              docsPerKindFiltered,
              nauticalPdColor
            );
          }
        }}
        initialValues={initialValues}
        onSubmit={(values, actions) =>
          onSubmit(
            values,
            actions,
            forMe,
            setErrorFormik,
            mutate,
            nauticalPdColor,
            id
          )
        }
      >
        {({ values }) => (
          <>
            {/* {Object.keys(errors)?.filter((error) => error !== "documents")
              ?.length !== 0
              ? setErrorFormik(t("Required Applicant Details missing"))
              : setErrorFormik("")} */}

            {(isLoading || isMutationLoading) && <CircularProgress />}
            {statusAppl == INITIAL_SUBMIT ? (
              <Form
                error={error}
                setError={setError}
                applicationKinds={applicationKinds}
                port_auth={port_auth}
                // errorFormik={errorFormik}
                disableAll={isLoading || isMutationLoading}
                translatedGender={translatedGender}
                docsPerKindFiltered={docsPerKindFiltered}
              />
            ) : (
              <>
                <SuccessScreen
                  protocolNumber={protocolNumber}
                  statusAppl={values.status}
                />
              </>
            )}
          </>
        )}
      </Formik>
    </>
  );
};

export default NewApplication;
